import { render } from "./TkEngagementCustomFieldsPanel.vue?vue&type=template&id=096ef76a&scoped=true"
import script from "./TkEngagementCustomFieldsPanel.vue?vue&type=script&lang=js"
export * from "./TkEngagementCustomFieldsPanel.vue?vue&type=script&lang=js"

import "./TkEngagementCustomFieldsPanel.vue?vue&type=style&index=0&id=096ef76a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096ef76a"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSpinner,QBadge,QForm,QCardSection,QInput,QSelect,QSeparator,QCardActions});qInstall(script, 'directives', {ClosePopup});
